import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import SolicitationNew from "../../../../../../presentation/pages/admin/solicitation/new";

import { IPackage } from "../../../../../../presentation/interfaces";

import { makeRemoteStack } from "../../../../usecases/stack/remote-stack-factory";
import { makeRemotePackage } from "../../../../usecases/package/remote-package-factory";
import { makeRemoteDeveloper } from "../../../../usecases/developer/remote-developer-factory";
import { makeRemoteCompanies } from "../../../../usecases/companies/remote-companies-factory";

import {
  taxTypeList,
  especialTaxTypeList,
  planStatusList,
  addressTypeList,
} from "../../../../../../utils";

import {
  handleCepChange,
  handleNoStackChange,
  getErrorMessage,
  makeDeveloper,
  makeCompany,
  makeCertificate,
  hasCertificate,
  showErrorMessage,
  showWarningMessage,
  showSuccessMessage,
  handleCnpjChange,
} from "../../../../../../presentation/helpers";

const MakeSolicitationNew: React.FC = () => {
  const isSmallScreen = window.innerWidth < 768;

  const history = useHistory();

  const [errorMessage] = useState<string | null>("");

  const [packages, setPackages] = useState<IPackage[]>([]);

  const [stacks, setStacks] = useState<any[]>([]);

  useEffect(() => {
    const fetchStacks = async (): Promise<void> => {
      const response = await makeRemoteStack().loadAll();
      setStacks(response);
    };
    fetchStacks();
  }, []);

  useEffect(() => {
    const fetchPackages = async (): Promise<void> => {
      const remotePackage = makeRemotePackage();
      try {
        const response = await remotePackage.loadAll();
        setPackages(response);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages();
  }, []);

  const makeSolicitation = (data: any): any => ({
    ...makeDeveloper(data),
    company: makeCompany(data),
    pack: {
      id: data?.plan,
    },
    planStatus: data?.planStatus
  });

  const handleError = (error: any): void => {
    showWarningMessage(getErrorMessage(error));
  };

  const uploadCertificate = async (
    data: any,
    companyId?: number,
  ): Promise<void> => {
    if (!hasCertificate(data)) return;

    try {
      await makeRemoteCompanies().createCertificate(
        makeCertificate(data, String(companyId)),
      );
    } catch (error: any) {
      handleError(error);
    }
  };

  const handleSubmit = async (data: any): Promise<void> => {
    try {
      console.log("HANDLE_SUBMIT_ADMIN: ", data);
      const createdSolicitation = await makeRemoteDeveloper().adminCreate(
        makeSolicitation(data),
      );

      showSuccessMessage("Solicitação criada com sucesso");

      await uploadCertificate(data, createdSolicitation?.company?.id);

      history.push(`/admin/developers/edit/${createdSolicitation.id}`);
    } catch (error: any) {
      showErrorMessage(getErrorMessage(error));
    }
  };

  const goBack = (): void => {
    history.goBack();
  };

  const dataForm = [
    {
      items: [
        {
          name: "title",
          component: "Title",
          title: "Dados pessoais: ",
          number: 1,
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "2fr 1fr" },
          inputs: [
            {
              name: "name",
              component: "Input",
              value: "",
              title: "Nome",
              label: "Nome",
              required: true,
              validations: "inputRequired",
            },
            {
              component: "InputMask",
              mask: "CPF",
              name: "cpf",
              label: "CPF",
              title: "CPF",
              value: "",
              required: true,
              validations: "cpfValidation",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: isSmallScreen ? "1fr 1fr" : "1fr 1fr 1fr",
          },
          inputs: [
            {
              name: "email",
              component: "Input",
              value: "",
              title: "E-mail",
              label: "E-mail",
              required: true,
              validations: "emailRequired",
            },
            {
              component: "InputMask",
              mask: "PHONE_NUMBER",
              name: "phone",
              label: "Telefone",
              title: "Telefone",
              value: "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: isSmallScreen ? "1fr 1fr" : "2fr 1fr",
          },
          hasDivider: true,
          inputs: [
            {
              name: "stacks",
              title: "Stacks",
              component: "Multiselect",
              styleContainer: { margin: "0px" },
              initialSelectedOptions: [],
              options: stacks
                .filter((stack) => stack.description !== "Não desejo informar")
                .map((stack) => ({
                  label: stack.description,
                  value: stack.id,
                })),
            },
            {
              component: "InputGroup",
              style: { display: "flex", flexDirection: "column" },
              inputs: [
                {
                  name: "otherStack",
                  component: "MultipleTextInput",
                  styleContainer: { margin: "0px" },
                  value: "",
                  title: "Outra stack",
                  label: "Outra stack",
                },
                {
                  name: "noStack",
                  component: "InputCheck",
                  title: "",
                  label: "",
                  onChange: (value: any, el: any) =>
                    handleNoStackChange(value, el, stacks),
                  options: [
                    {
                      value: "true",
                      label: "Não desejo informar",
                      name: "Não desejo informar",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: "title",
          component: "Title",
          title: "Endereço Residencial: ",
          number: 2,
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: "1fr 2fr",
          },
          inputs: [
            {
              name: "developerCep",
              component: "InputMask",
              mask: "CEP",
              label: "CEP",
              title: "CEP",
              value: "",
              required: true,
              validations: "inputRequired",
              onChange: (data: any, el: any) =>
                handleCepChange(data, el, "developer"),
            },
            {
              component: "Input",
              name: "developerStreet",
              label: "Rua",
              title: "Rua",
              value: "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr" },
          inputs: [
            {
              name: "developerNumber",
              component: "Input",
              label: "Número",
              title: "Número",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "developerNeighborhood",
              component: "Input",
              label: "Bairro",
              title: "Bairro",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "developerComplement",
              component: "Input",
              label: "Complemento",
              title: "Complemento",
              value: "",
              required: false,
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr" },
          hasDivider: true,
          inputs: [
            {
              name: "developerCity",
              component: "Input",
              label: "Cidade",
              title: "Cidade",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "developerState",
              component: "Input",
              label: "Estado",
              title: "Estado",
              value: "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          name: "title",
          component: "Title",
          title: "Dados CNPJ: ",
          number: 3,
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "2fr 1fr" },
          inputs: [
            {
              name: "socialReason",
              component: "Input",
              label: "Razão Social",
              title: "Razão Social",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              component: "InputMask",
              mask: "CNPJ",
              name: "cnpj",
              label: "CNPJ",
              title: "CNPJ",
              value: "",
              onChange: (data: any, el: any) =>
                  handleCnpjChange(data, el),
              required: true,
              validations: "cpnjValidation",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            alignItems: "center",
          },
          inputs: [
            {
              name: "stateRegistration",
              component: "Input",
              label: "Inscrição Estadual",
              title: "Inscrição Estadual",
              value: "",
            },
            {
              name: "municipalRegistration",
              component: "Input",
              label: "Inscrição Municipal",
              title: "Inscrição Municipal",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "isMei",
              component: "InputCheck",
              title: "",
              label: "",
              options: [
                {
                  value: "true",
                  label: "O CNPJ é MEI?",
                  name: "O CNPJ é MEI?",
                },
              ],
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "2fr 1fr" },
          inputs: [
            {
              name: "fantasyName",
              component: "Input",
              label: "Nome Fantasia",
              title: "Nome Fantasia",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              component: "Input",
              name: "companyEmail",
              label: "E-mail Cadastrado",
              title: "E-mail Cadastrado",
              value: "",
              required: true,
              validations: "emailRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr" },
          inputs: [
            {
              name: "companyPhone",
              component: "InputMask",
              mask: "PHONE_NUMBER",
              label: "Telefone",
              title: "Telefone",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "taxType",
              component: "Select",
              label: "Regime Tributário",
              title: "Regime Tributário",
              value: "",
              required: true,
              validations: "inputRequired",
              options: taxTypeList.map((tax) => ({
                value: tax.ENUM,
                label: tax.label,
              })),
            },
            {
              name: "especialTaxType",
              component: "Select",
              label: "Regime Tributário Especial",
              title: "Regime Tributário Especial",
              value: "",
              required: true,
              validations: "inputRequired",
              options: especialTaxTypeList.map((tax) => ({
                value: tax.ENUM,
                label: tax.label,
              })),
            },
          ],
        },
        {
          component: "InputGroup",
          hasDivider: true,
          style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr" },
          inputs: [
            {
              name: "simplesNacional",
              component: "InputCheck",
              title: "",
              label: "",
              options: [
                {
                  value: "true",
                  label: "Optante pelo Simples Nacional",
                  name: "Optante pelo Simples Nacional",
                },
              ],
            },
            {
              name: "culturalIncentive",
              component: "InputCheck",
              title: "",
              label: "",
              options: [
                {
                  value: "true",
                  label: "Incentivo a Cultura",
                  name: "Incentivo a Cultura",
                },
              ],
            },
            {
              name: "taxIncentive",
              component: "InputCheck",
              title: "",
              label: "",
              options: [
                {
                  value: "true",
                  label: "Taxa de incentivo",
                  name: "Taxa de incentivo",
                },
              ],
            },
          ],
        },
        {
          name: "title",
          component: "Title",
          title: "Certificado Digital: ",
          number: 4,
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
          },
          hasDivider: true,
          inputs: [
            {
              name: "certificateFile",
              component: "InputUpload",
              label: "Certificado Digital",
              title: "Certificado Digital",
              value: "",
              accept: ".pfx",
            },
            {
              name: "certificatePassword",
              component: "InputPassword",
              type: "password",
              label: "Senha do Certificado",
              title: "Senha do Certificado",
              value: "",
            },
            {
              name: "certificateEmail",
              component: "Input",
              label: "E-mail Cadastrado",
              title: "E-mail Cadastrado",
              value: "",
            },
          ],
        },
        {
          name: "title",
          component: "Title",
          title: "Endereço do CNPJ6: ",
          number: 5,
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
          },
          inputs: [
            {
              name: "companyCep",
              component: "InputMask",
              mask: "CEP",
              label: "CEP",
              title: "CEP",
              value: "",
              required: true,
              validations: "inputRequired",
              onChange: (data: any, el: any) =>
                handleCepChange(data, el, "company"),
            },
            {
              name: "tipoLogradouro",
              component: "Select",
              label: "Tipo de Logradouro",
              title: "Tipo de Logradouro",
              value: "",
              required: true,
              validations: "inputRequired",
              options: addressTypeList.map((address) => ({
                value: address.ENUM,
                label: address.label,
              })),
            },
            {
              component: "Input",
              name: "companyStreet",
              label: "Rua",
              title: "Rua",
              value: "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr" },
          inputs: [
            {
              name: "companyNumber",
              component: "Input",
              label: "Número",
              title: "Número",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "companyNeighborhood",
              component: "Input",
              label: "Bairro",
              title: "Bairro",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "companyComplement",
              component: "Input",
              label: "Complemento",
              title: "Complemento",
              value: "",
              required: false,
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr" },
          hasDivider: true,
          inputs: [
            {
              name: "companyCity",
              component: "Input",
              label: "Cidade",
              title: "Cidade",
              value: "",
              required: true,
              validations: "inputRequired",
            },
            {
              name: "companyState",
              component: "Input",
              label: "Estado",
              title: "Estado",
              value: "",
              required: true,
              validations: "inputRequired",
            },
          ],
        },
        {
          name: "title",
          component: "Title",
          title: "Plano4: ",
          number: 6,
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: isSmallScreen ? "1fr 1fr" : "1fr 1fr 1fr",
          },
          hasDivider: true,
          inputs: [
            {
              name: "plan",
              component: "Select",
              required: true,
              validations: "inputRequired",
              label: "Plano",
              title: "Plano",
              value: "",
              options: packages.map((pack) => ({
                value: pack.id,
                label: pack.packageEnum,
              })),
            },
            {
              name: "planStatus",
              component: "Select",
              label: "Status",
              title: "Status",
              required: true,
              validations: "inputRequired",
              value: "",
              options: planStatusList,
            },
          ],
        },
        {
          component: "InputGroup",
          style: { display: "flex", gap: "16px", width: "100%", marginTop: 16 },
          inputs: [
            {
              name: "backButton",
              component: "Button",
              type: "button",
              title: "Voltar",
              onClick: goBack,
              color: false,
            },
            {
              name: "button",
              component: "Button",
              title: "Enviar",
              submittingText: "Carregando...",
              color: true,
            },
          ],
        },
      ],
    },
  ];

  const props = {
    dataForm,
    onSubmit: handleSubmit,
    errorMessage,
  };

  return <SolicitationNew {...props} />;
};

export default MakeSolicitationNew;
